import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  onboardingMessage: 'Loading...',
  message: 'Loading assets...',
  totalProps: 0,
  totalMaterials: 0,
  loadedProps: 0,
  loadedMaterials: 0,
  hidden: false,
};

const curatorLoadingProgressBarSlicer = createSlice({
  name: 'curatorLoadingProgressBar',
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    setOnboardingMessage: (state, { payload }) => {
      state.onboardingMessage = payload;
    },
    setMessage: (state, { payload }) => {
      state.message = payload;
    },
    setTotalProps: (state, { payload }) => {
      state.totalProps = payload;
    },
    setTotalMaterials: (state, { payload }) => {
      state.totalMaterials = payload;
    },
    addLoadedProp: (state, { payload }) => {
      state.loadedProps += 1;
    },
    addLoadedMaterial: (state, { payload }) => {
      state.loadedMaterials += 1;
    },
    setHidden: (state, { payload }) => {
      state.hidden = payload;
    }
  },
});

export const { setMessage, setTotalProps, setTotalMaterials, addLoadedProp, addLoadedMaterial  } = curatorLoadingProgressBarSlicer.actions;
export const curatorLoadingProgressBarActions = curatorLoadingProgressBarSlicer.actions

export const curatorLoadingProgressBarReducer = curatorLoadingProgressBarSlicer.reducer;

export const selectProgressMessage = (state) => state.curatorLoadingProgressBar.message;
export const selectProgressTotal = (state) => {
  const { totalProps, totalMaterials  }  = state.curatorLoadingProgressBar
  return totalProps + totalMaterials;
};
export const selectProgressLoaded = (state) => {
  const { loadedProps, loadedMaterials } = state.curatorLoadingProgressBar
  return loadedProps + loadedMaterials;
};

export const selectProgressHidden = (state) => {
  return state.curatorLoadingProgressBar.hidden;
}

export const selectProgressOnboardingMessage = (state) => state.curatorLoadingProgressBar.onboardingMessage;